import jsonConfig from './../jsonconfig.json';

export const Config = {
  DEBUG: jsonConfig.DEBUG,
  API_BASE_URL: jsonConfig.API_BASE_URL ?? '',
  VERSION: '1.0.6',
  DEFAULT_CLIENT_AUTHKEY: jsonConfig.DEFAULT_CLIENT_AUTHKEY ?? '',
  VISITOR_REGISTRATION_WITH_STEPS: true,
};
